
{
    angular.module('utilsModule')
        .factory('utils.uploadManager', uploadManager);
    uploadManager.$inject = ['utils.constant','FileUploader','$state'];
    function uploadManager(constant,FileUploader,$state) {
        let collect={
            'uploader':null,
            'init':init,
            'callbackDelegateList':[],
            'currentFileItem':null,
            // 'currentPrintType':-1,//打印类型，-1未知，0文档，1论文
        }

        function init(){
            if(collect.uploader){
                return;
            }
            let uploader = collect.uploader=new FileUploader({
                url: constant.config.sitePath+constant.action.upload,
                // formData:[{'a':0,'b':1}],
                alias :'Filedata'
            });

            //只能上传文件的过滤器：docFilter
            uploader.filters.push({
                name: 'docFilter',
                fn: function(item /*{File|FileLikeObject}*/, options) {
                    //console.log("看看这个item是什么：",item);
                    //console.log("看这个options：",options);


                    var type = '|' + item.name.slice(item.name.lastIndexOf('.') + 1) + '|';

                    return '|doc|docx|ppt|pptx|pdf|'.indexOf(type) !== -1&&item.size<=50*1024*1024;
                }
            });



            // CALLBACKS
            function doCallback(funcName,...args){

                // console.log('doCallback',collect.callbackDelegateList.length);
                for(let i=0;i<collect.callbackDelegateList.length;i++){
                    // console.log(typeof(collect.callbackDelegateList[i].onProgressItem));
                    if(typeof(collect.callbackDelegateList[i][funcName])=='function'){
                        collect.callbackDelegateList[i][funcName](...args);
                    }
                }
            }
            //添加文件到上传队列失败后
            uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
                // console.info('onWhenAddingFileFailed', item, filter, options);
                doCallback('onWhenAddingFileFailed',item, filter, options);
            };
            //添加文件到上传队列后
            uploader.onAfterAddingFile = function(fileItem) {
                // console.log(uploader.queue);
                // uploader.formData=[{'a':0,'b':1}];
                collect.currentFileItem=fileItem;
                uploader.queue[0].upload();
                doCallback('onAfterAddingFile',fileItem);
            };
            //添加所选的所有文件到上传队列后
            uploader.onAfterAddingAll = function(addedFileItems) {

            };
            //文件上传之前
            uploader.onBeforeUploadItem = function(item) {
                if(item.file.name.length > 18){
                    let title1 = item.file.name.substring(0,4);
                    let title2 = item.file.name.substring(item.file.name.length-7,item.file.name.length);
                    let title = title1 + '···' + title2;
                    item.file.name = title;
                }
                console.log('上传文件之前修改过的文件名:',item);
                doCallback('onBeforeUploadItem',item);
            };
            //文件上传中
            uploader.onProgressItem = function(fileItem, progress) {
                doCallback('onProgressItem',fileItem, progress);
            };
            //上传队列的所有文件上传中
            uploader.onProgressAll = function(progress) {

            };
            //文件上传成功后
            uploader.onSuccessItem = function(fileItem, response, status, headers) {
                collect.currentFileItem=fileItem;
                doCallback('onSuccessItem',fileItem, response, status, headers);
            };
            //文件上传失败后
            uploader.onErrorItem = function(fileItem, response, status, headers) {
                
                doCallback('onErrorItem',fileItem, response, status, headers);
            };
            //文件上传取消后
            uploader.onCancelItem = function(fileItem, response, status, headers) {
                
                doCallback('onCancelItem',fileItem, response, status, headers);
            };
            //文件上传完成后
            uploader.onCompleteItem = function(fileItem, response, status, headers) {

            };
            //上传队列的所有文件上传完成后
            uploader.onCompleteAll = function() {

            };

            // console.info('uploader', uploader);
        }


        return collect;
    }

}